import UIDs from "../../../../../UIDs";

const uid = UIDs.screens.admin.course.list;

const ActionTypes = {
    LOAD_SCREEN_VIEW_ASYNC: `${uid}.loadScreenViewAsync`,
    LOAD_SCREEN_VIEW_SUCCESS: `${uid}.loadScreenViewSuccess`,
    LOAD_SCREEN_VIEW_FAILURE: `${uid}.loadScreenViewFailure`,
    DELETE_COURSE_ASYNC: `${uid}.deleteCourseAsync`,
    DELETE_COURSE_SUCCESS: `${uid}.deleteCourseSuccess`,
    DELETE_COURSE_FAILURE: `${uid}.deleteCourseFailure`,
    UPDATE_FILTER_BY: `${uid}.updateFilterBy`,
    ADD_TEACHER_ASYNC: `${uid}.addTeacherAsync`,
    ADD_TEACHER_SUCCESS: `${uid}.addTeacherSuccess`,
    ADD_TEACHER_FAILURE: `${uid}.addTeacherFailure`,
    UPDATE_SCREEN_STATE: `${uid}.updateScreenState`,
};

export { ActionTypes };
